import { Box, Stack, Typography, Button as MuiButton } from '@mui/material';
import { ComponentProps } from 'react';
import { Icon } from '@/units/index';

type Props = {
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: (() => void) | null;
  isButtonVisible?: boolean;
} & ComponentProps<typeof Stack>;

export function NoNotesFound({ title, description, buttonText, onButtonClick, isButtonVisible = true, sx, ...props }: Props) {
  return (
    <Stack {...props} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', ...sx }}>
      <Box
        sx={{
          mb: '16px',
          display: 'flex',
          width: '48px',
          height: '48px',
          padding: '12px',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '28px',
          border: '8px solid var(--Gray-50, #F9FAFB)',
          background: 'var(--Gray-100, #F2F4F7)',
        }}
      >
        <i className="fa-regular fa-magnifying-glass" style={{ fontSize: '18px', color: '#2055FF' }} />
      </Box>
      <Stack sx={{ mb: '24px' }}>
        <Typography
          sx={{
            color: 'var(--Gray-900, #101828)',
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '24px',
            mb: '4px',
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            color: 'var(--Gray-500, #667085)',
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '20px',
            width: '220px',
            whiteSpace: 'wrap',
          }}
        >
          {description}
        </Typography>
      </Stack>

      {onButtonClick && isButtonVisible && (
        <MuiButton
          variant="contained"
          startIcon={<Icon.Add />}
          sx={{
            backgroundColor: '#2055FF',
            color: 'var(--White, #FFF)',
            borderRadius: '8px',
            padding: '10px 32px',
            width: '194px',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '24px',
            'box-shadow': '0px 1px 2px 0px #1018280D',
            '& .MuiButton-startIcon': {
              marginRight: '8px',
            },
          }}
          onClick={onButtonClick}
        >
          {buttonText}
        </MuiButton>
      )}
    </Stack>
  );
}
